import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";

interface MyLeaveInfoDialogProps {
  showDialog: boolean;
  closeDialog: () => void;
  title: React.ReactNode;
  text: React.ReactNode;
  buttonLabel: React.ReactNode;
}

export const MyLeaveInfoDialog = ({
  showDialog,
  closeDialog,
  title,
  text,
  buttonLabel,
}: MyLeaveInfoDialogProps) => {
  const handleCloseDialog = () => {
    closeDialog();
  };

  return (
    <Dialog
      id="my-leave-info-dialog"
      aria-labelledby="new-request-dialog-title"
      open={showDialog}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          return false;
        }
      }}
      disableEscapeKeyDown
      scroll="body"
      PaperProps={{
        style: { padding: "0px 24px 24px 24px", width: 528 },
      }}
    >
      <Box height="24px" />
      <Box
        style={{
          textAlign: "center",
        }}
      >
        <Typography variant="h5">{title}</Typography>
      </Box>
      <DialogContent>
        <Box style={{ textAlign: "center", padding: 30 }}>
          <Typography variant="body1">{text}</Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Button
            id="my-leave-info-dialog-close-button"
            fullWidth
            variant="contained"
            color="primary"
            disableElevation
            onClick={handleCloseDialog}
          >
            {buttonLabel}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default MyLeaveInfoDialog;
